import {
  jb_text_with_image_css_default
} from "./chunk.XFKM7CZU.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-text-with-image/jb-text-with-image.ts
var JbTextWithImage = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return {
      colsMdUp: 12,
      type: "text"
    };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "text-with-image"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <article
        class="${e({
      [this.imageAlign]: true,
      [this.imageOrientation]: true,
      [this.imageSize]: true
    })}"
      >
        <jb-image
          .caption=${this.image.caption}
          .credit=${this.image.credit}
          .picture=${this.image.picture}
          .text=${this.image.text}
        ></jb-image>
        <div class="slotwrapper">
          <slot @jb-link:clicked=${this._tracking}></slot>
        </div>
      </article>
    `;
  }
};
JbTextWithImage.styles = [reset_css_default, jb_text_with_image_css_default];
__decorateClass([
  n({ type: Object })
], JbTextWithImage.prototype, "image", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageAlign", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageOrientation", 2);
__decorateClass([
  n()
], JbTextWithImage.prototype, "imageSize", 2);
JbTextWithImage = __decorateClass([
  customElement("jb-text-with-image")
], JbTextWithImage);

export {
  JbTextWithImage
};
